/* 
Temporary fix to hide the horizontal scrollbar in in-meeting experience.
The horizontal scrollbar appears because QnA container has min-wdith 280px, but Teams provides only 279px. 
This is a bug on Teams side and we have already reported it here - https://domoreexp.visualstudio.com/MSTeams/_workitems/edit/2268465
We can remove this temporary fix after Teams fix their bug or if we move to native QnA experience, whichever happens first.
*/

import type { ComponentClassNames } from '@ms/yammer-web-core-ui/dist/util/classNames';
import { memoizeFunction, mergeStyleSets } from '@ms/yammer-web-core-ui/dist/util/styling';

type GetClassNames = () => ComponentClassNames<'app'>;
export const getClassNames: GetClassNames = memoizeFunction(() =>
  mergeStyleSets({
    app: {
      overflowX: 'hidden',
    },
  })
);
